import React from 'react';

const mealLabels = {
  breakfast: 'Frühstück',
  lunch: 'Mittagessen',
  dinner: 'Abendessen',
};

const formatTimestamp = timestamp => timestamp
  ? new Date(timestamp).toLocaleString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Berlin',
    })
  : null;

const OrderEditHistory = ({ entries = [] }) => {
  if (!entries.length) return null;

  return (
    <div className="mt-3 space-y-2" data-order-edit-history>
      {entries.map((entry, entryIndex) => (
        <div key={`${entry.timestamp || 'edit'}-${entryIndex}`} className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-slate-700">
          <p className="font-semibold text-amber-900">
            Bestellung geändert{formatTimestamp(entry.timestamp) ? ` · ${formatTimestamp(entry.timestamp)}` : ''}
          </p>
          {(entry.changes || []).length > 0 ? (
            <div className="mt-1.5 space-y-1.5">
              {entry.changes.map((change, changeIndex) => (
                <div key={`${change.meal_type || 'change'}-${changeIndex}`}>
                  <p className="font-medium text-slate-800">{mealLabels[change.meal_type] || 'Bestellung'}</p>
                  <p>Vorher: {change.before || 'Keine Angabe'}</p>
                  <p>Nachher: {change.after || 'Keine Angabe'}</p>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default OrderEditHistory;
